import React, { useEffect, useState } from "react"
import { Button, Card, Divider, Loader, Dimmer, Image } from "semantic-ui-react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { getUpdatedCart } from "../../../v1/helpers/orderHelpers"
import { routerPaths } from "../../../v1/constants/paths"
import { updateCart } from "../../../v1/actions/user"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../shared_component/utils/googleAnalyticsHelpers"
import { withRouter } from "react-router-dom"
import ServiceTile from "./ReviewRequest/ServiceTile"
import { PricedAtShop } from "./PricedAtShop"
import { trackEvent } from "../../../shared_component/utils/segmentAnalytics"
import { getShopAddress, getShopName } from "../../../v1/helpers/shopHelpers"
import store from "../../../shared_component/utils/configureStore"
import Notifications from "../../../v1/components/Notifications"
import InfoIcon from "../../../images/info-Icon.svg"

const ReviewAppointment = ({ t, history, cart, user, activeVehicle, updateCart, order, props }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [services, setServices] = useState([])
  const subtotal = services.reduce((sum, service) => {
    const rawPrice = service?.price_estimate?.shop_price_estimate
    const price = parseFloat(rawPrice)
    return sum + (!isNaN(price) ? price : 0)
  }, 0)

  useEffect(() => {
    updateCartWithOldVehicle()
  }, [])

  const updateCartWithOldVehicle = async () => {
    const comparePriceData = JSON.parse(localStorage.getItem("comparePriceData"))
    if (comparePriceData) {
      await updateService(comparePriceData)
      await handleShopSelect(comparePriceData)
    } else {
      setServices(cart.order_services)
    }
  }

  const updateService = async (comparePriceData) => {
    setIsLoading(true)
    const allServices = []
    const servicesToAdd = comparePriceData.selectedServices

    servicesToAdd.forEach((os) => {
      allServices.push({
        service_definition_id: os.service_id || os.id || os.service_definition_id,
        event: "added",
        prepaid: os.prepaid,
        position: os.position
      })
    })

    let opts = {
      successCallback: async () => {
        trackFirebaseAnalytics({
          event: gaJSON.service_selected,
          params: {
            [gaJSON.services]: allServices,
            [gaJSON.from_where]: window.location.hash,
            [gaJSON.vehicle_name]: activeVehicle
              ? `${activeVehicle?.year || ""} ${activeVehicle?.make?.toUpperCase() || ""} ${
                  activeVehicle?.model?.toUpperCase() || ""
                }`
              : null
          }
        })
      }
    }

    try {
      if (allServices.length > 0) {
        await updateCart(allServices, user.activeVehicleId, undefined, undefined, opts)
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: error.toString(),
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
    }
  }

  const handleShopSelect = async (comparePriceData) => {
    setIsLoading(true)
    const shopId = comparePriceData.selectedShopId
    let opts = {
      successCallback: async (response) => {
        await trackEvent("click-service-center", {
          shopAddress: getShopAddress(response.shop),
          shopCity: response.shop && response.shop.city,
          shopName: getShopName({
            shop: response.shop,
            company: response.shop && response.shop.company
          }),
          shopId: response.shop && parseInt(response.shop.id),
          eventSourceName: "Checkout_2.0"
        })
      }
    }

    const response = await updateCart(
      [{ event: "set_shop", shop_id: shopId }],
      undefined,
      undefined,
      true,
      opts
    )

    if (response && response().result) {
      const cart = response().result
      setServices(cart.order_services)
      const subtotal = cart.order_services.reduce((sum, service) => {
        const rawPrice = service?.price_estimate?.shop_price_estimate
        const price = parseFloat(rawPrice)
        return sum + (!isNaN(price) ? price : 0)
      }, 0)
      if (subtotal == comparePriceData.subTotal) {
        localStorage.setItem("comparePriceData", null)
        history.push({ pathname: routerPaths.appointment })
      }
      localStorage.setItem("comparePriceData", null)
      setIsLoading(false)
    }
    if (response().error) {
      setIsLoading(false)
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: response().error.toString(),
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
    }
  }

  const getServices = () => {
    let updatedCartData = getUpdatedCart(user, order, props)
    setServices(updatedCartData.cart.order_services)
  }

  const removeService = async (os, event) => {
    setIsLoading(true)
    let opts = {
      isOrder: order && !order.is_tire_order,
      orderId: order && order.id,
      successCallback: async () => {
        trackFirebaseAnalytics({
          event: gaJSON.service_selected,
          params: {
            [gaJSON.service_name]: os.name,
            [gaJSON.service_type]: !os.position ? os.name : `${os.name} - ${os.position}`,
            [gaJSON.from_where]: window.location.hash,
            [gaJSON.vehicle_name]: activeVehicle
              ? `${activeVehicle?.year || ""} ${activeVehicle?.make?.toUpperCase() || ""} ${
                  activeVehicle?.model?.toUpperCase() || ""
                }`
              : null
          }
        })
      }
    }
    try {
      await updateCart(
        [
          {
            service_definition_id: os.service_id || os.id || os.service_definition_id,
            event: event,
            prepaid: os.prepaid,
            position: os.position
          }
        ],
        cart.vehicle_id,
        undefined,
        undefined,
        opts
      )
      getServices()
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: error.toString(),
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
    }
  }

  const handleConfirm = () => {
    history.push({ pathname: routerPaths.appointment })
  }

  const handleBackToShop = () => {
    history.push({ pathname: routerPaths.shopSelection })
  }

  return (
    <>
      <Dimmer active={isLoading}>
        <Loader>Loading...</Loader>
      </Dimmer>
      {!isLoading && (
        <Card className="compare-service-card review-request-container" raised>
          <div className="compare-service-content">
            <p className="compare-request-title">
              <b>{t("YourPriceHasBeenUpdated")}</b>
            </p>
            <Card fluid className="compare-vehicle-info">
              <Image src={InfoIcon} />
              <span>
                <b>{t("weUpdatedEstimate")}</b> {t("someServices")}
              </span>
            </Card>
            {services.map((service, idx) => (
              <ServiceTile
                key={service.id}
                service={service}
                handleService={removeService}
                cart={cart}
              />
            ))}
            <Divider />
            <div className="compare-services-subtotal-row">
              <span>{t("subtotal")}</span>
              {subtotal != 0 && user && user.country !== "ca" ? (
                <b className="review-services-subtotal">
                  {t("starting")} ${Number(subtotal).toFixed(2)}
                </b>
              ) : (
                <PricedAtShop />
              )}
            </div>
          </div>
          <Button
            fluid
            color="orange"
            className="primary-button"
            onClick={handleConfirm}
            disabled={services.length === 0}
            style={{ marginBottom: "10px" }}
          >
            {t("confirmAndContinue")}
          </Button>
          <Button fluid basic color="black" className="secondary-button" onClick={handleBackToShop}>
            {t("backToShopPricing")}
          </Button>
        </Card>
      )}
    </>
  )
}
function mapStateToProps(state, props) {
  let user = state.user || {}
  let cart
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  const order =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)
  let updatedCartData = getUpdatedCart(user, order, props)
  if (updatedCartData) {
    cart = updatedCartData.cart
  }

  return {
    cart: cart,
    user: user,
    activeVehicle,
    order,
    props
  }
}

export default withRouter(
  connect(mapStateToProps, { updateCart })(withTranslation("addService")(ReviewAppointment))
)
